<template>
  <div class="change-pwd-panel">
    <div class="panel-header">
      <h2 class="panel-title">修改登录密码</h2>
      <p class="panel-desc">为了保护您的政企采购账户安全，建议定期更换密码，避免使用与其他网站相同的密码</p>
    </div>

    <div class="form-wrapper">
      <el-form ref="form" :model="form" label-width="110px" size="medium" class="pwd-form">
        <el-form-item label="当前原密码" required>
          <el-input
            v-model="form.oldPwd"
            type="password"
            show-password
            placeholder="请输入当前正在使用的原密码"
          ></el-input>
        </el-form-item>

        <el-form-item label="设置新密码" required>
          <el-input
            v-model="form.newPwd"
            type="password"
            show-password
            placeholder="请输入新密码（建议包含字母与数字组合）"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认新密码" required>
          <el-input
            v-model="form.againNewPwd"
            type="password"
            show-password
            placeholder="请再次确认新密码"
          ></el-input>
        </el-form-item>

        <el-form-item class="form-action-item">
          <el-button type="primary" :loading="loading" class="btn-submit" @click="confirm">
            确认修改密码
          </el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 安全说明 -->
      <div class="security-tips-card">
        <div class="tip-title">
          <i class="el-icon-shield"></i>
          <span>密码安全须知</span>
        </div>
        <ul class="tip-list">
          <li>密码长度建议在 6-20 位之间，支持字母、数字及常见特殊符号；</li>
          <li>切勿将采购账户密码透露给他人或用于非官方认证的采购渠道；</li>
          <li>密码修改成功后，请使用新密码重新登录系统以刷新认证凭证。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { changePwd } from "@/api/platform";

export default {
  name: 'ChangePwd',
  data () {
    return {
      loading: false,
      form: {
        oldPwd: '',
        newPwd: '',
        againNewPwd: "",
      }
    }
  },
  methods: {
    resetForm () {
      this.form = {
        oldPwd: '',
        newPwd: '',
        againNewPwd: '',
      }
    },
    async confirm () {
      const { oldPwd, newPwd, againNewPwd } = this.form
      if (!oldPwd) return this.$message.warning('请输入当前旧密码');
      if (!newPwd) return this.$message.warning('请输入新密码');
      if (newPwd.length < 6) return this.$message.warning('新密码长度不能少于 6 位');
      if (!againNewPwd) return this.$message.warning('请再次输入新密码');
      if (newPwd !== againNewPwd) return this.$message.warning('两次输入的新密码不一致，请核对');

      this.loading = true
      try {
        await changePwd({
          oldpassword: oldPwd,
          password: newPwd,
        })
        this.$message.success('登录密码修改成功，请牢记您的新密码');
        this.resetForm()
      } catch (e) {
        this.$message.error('密码修改失败，请检查原密码是否正确');
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';

.change-pwd-panel {
  width: 100%;

  .panel-header {
    padding-bottom: 16px;
    margin-bottom: 24px;
    border-bottom: 1px solid #f1f5f9;

    .panel-title {
      font-size: 16px;
      font-weight: 700;
      color: #0f172a;
      margin: 0 0 6px;
    }

    .panel-desc {
      font-size: 13px;
      color: #64748b;
      margin: 0;
    }
  }

  .form-wrapper {
    display: flex;
    gap: 40px;
    align-items: flex-start;

    .pwd-form {
      width: 440px;
      flex-shrink: 0;

      .form-action-item {
        margin-top: 28px;

        .btn-submit {
          background-color: @brandPrimary;
          border-color: @brandPrimary;
          font-weight: 600;
          padding: 10px 24px;
          border-radius: 6px;

          &:hover {
            background-color: @brandSecondary;
            border-color: @brandSecondary;
            box-shadow: 0 4px 12px rgba(15, 82, 186, 0.25);
          }
        }
      }
    }

    .security-tips-card {
      flex: 1;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 20px;

      .tip-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 700;
        color: #1e293b;
        margin-bottom: 12px;

        i {
          color: @brandPrimary;
          font-size: 16px;
        }
      }

      .tip-list {
        margin: 0;
        padding-left: 18px;
        font-size: 13px;
        line-height: 1.8;
        color: #64748b;

        li {
          margin-bottom: 6px;
          &:last-child { margin-bottom: 0; }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/ChangePwd.vue